//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, inject, OnInit } from '@angular/core';
import { BehaviorSubject, filter, first, firstValueFrom, Observable, take } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';


//-================ IMPORTS FOR CONSTANTS ================-\\

//-================ IMPORTS FOR DEPENDENCIES ================-\\
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { GeneralLibraryCDMS, LibraryCDMS, typeSystemLibraryCDMS } from 'src/app/types/General/Library.type';
import { TASK_ALL_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/All-Task-CCP.interface';
import { TASK_ALL_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/All-Task-FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Group_Library_Task } from 'src/app/Interfaces/Interfaces-Global/Libraries.interface';
import { UserDataCDMS } from 'src/app/Interfaces/GeneralCDMS/User/User.interface';


@Component({
    selector: 'app-all-task-all-library',
    templateUrl: './all-task-all-library.component.html',
    styleUrls: ['./all-task-all-library.component.scss', '../../../Styles/GlobalStyles.css', '../../../Styles/LibrayGlobal.css', '../../../Styles/TasksGlobal.css'],
    standalone: false
})


export class AllTaskAllLibraryComponent implements OnInit {

  //+================== VARIABLE LIBRARY GENERAL ==================+\\
  public LibraryGeneral: typeSystemLibraryCDMS = GeneralLibraryCDMS;

  //+================== VARIABLES FOR OPTION CARDS LIBRARIES ==================+\\
  public AllLibraries: Group_Library_Task[] = []
  private AccessibleLibrarySlugs: Set<string> = new Set<string>();
  public LoadPage: boolean = false;

  public AllLibrariesCopy: Group_Library_Task[] = [
    {
      Title: 'Administrative Processes',
      NotRelated: [],
      LibraryRole: [this.LibraryGeneral.FIN],
      Library: [
        { Name_library: 'Processes', RouteLink: '/Dashboard/FIN/SeeAllTasksLibFIN', Task: 0, Key: this.LibraryGeneral.FIN },
      ],
    }
  ]

  //-========================= SECTION VARIABLES =========================-\\
  //+================== VARIABLES CREDENTIALS ==================+\\
  private ID_User_BD: number = 0;

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //-========================= SERVICES =========================-\\
  public UserService = inject(UserDataService);


  constructor(
    private Service_CCP: LIBRARYCCPService,
    private Service_FIN: LibraryFINService,
    private Service_Master: LibraryMasterService
  ) {
    this.ID_User_BD = Number(localStorage.getItem('ID_U_DB'));
  }

  async ngOnInit(): Promise<void> {

    await this.Load_Tasks();
    await this.Load_Task_Dynamic_Libraries();
    await this.fillTemplateTask();
    this.LoadPage = true;
  }
  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async fillTemplateTask(): Promise<void> {

    const userData: UserDataCDMS = await firstValueFrom(this.UserService.GetDataUser.pipe(first(value => value.ID !== 0)));
    const userLibraries: LibraryCDMS[] = this.AccessibleLibrarySlugs.size > 0
      ? Array.from(this.AccessibleLibrarySlugs.values()) as LibraryCDMS[]
      : userData.Library;

    this.AllLibraries = [];

    for (const library of this.AllLibrariesCopy) {
      const tempLibrary: Group_Library_Task = {
        Title: library.Title,
        NotRelated: [],
        LibraryRole: library.LibraryRole,
        Library: []
      };

      for (const contLibrary of library.Library) {
        if (contLibrary.Task > 0) {
          tempLibrary.Library.push(contLibrary);
        } else {
          tempLibrary.NotRelated.push(contLibrary.Key);
        }
      }

      this.AllLibraries.push(tempLibrary);
    }
  }

  public HasPendingTasks(): boolean {
    return this.AllLibraries.some((library) => library.Library.length > 0);
  }

  //-================== FUNCTTION FOR LOAD TASK GENERAL ==================-\\
  private async Load_Tasks(): Promise<void> {
    const Loader = document.getElementById('LoaderTask') as HTMLDivElement;
    Loader.classList.add('active');


    try {

      // this.Load_Task_CCP();
      await this.Load_Task_FIN();
      // this.Load_Task_SEC();

      Loader.classList.remove('active');
    } catch (e) {

      Loader.classList.remove('active');
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  //-================== FUNCTTION FOR LOAD TASK CCP ==================-\\
  private async Load_Task_CCP(): Promise<void> {

    try {

      const ResTask: any = await firstValueFrom(this.Service_CCP.GetTaskOfUser({ ID_Involved_User: this.ID_User_BD, Status: 1, IsConsultViewTask: false }))

      if (ResTask.success) {

        const Tasks: TASK_ALL_CCP[] = ResTask.operation;

        this.AllLibrariesCopy[0].Library[1].Task = Tasks.length;

      }


    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Tareas CCP)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

    }

  }

  //-================== FUNCTTION FOR LOAD TASK FIN ==================-\\
  private async Load_Task_FIN(): Promise<void> {

    try {

      const ResTask: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Task_Of_User({ ID_Involved_User: this.ID_User_BD, Status: 1, IsConsultViewTask: false }, 'fin'))

      if (ResTask.success) {

        const Tasks: TASK_ALL_FIN[] = ResTask.operation;

        this.AllLibrariesCopy[0].Library[0].Task = Tasks.length;

      }


    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Tareas finanzas)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    }

  }

  private async Load_Task_Dynamic_Libraries(): Promise<void> {
    try {
      const activeLibrariesRes: Response_FIN = await firstValueFrom(this.Service_Master.Get_My_Active_Libraries());
      if (!activeLibrariesRes.success) {
        return;
      }

      this.AccessibleLibrarySlugs = new Set(
        (activeLibrariesRes.operation || [])
          .map((lib: any) => String(lib?.Slug || '').trim().toLowerCase())
          .filter((slug: string) => slug.length > 0)
      );

      const dynamicLibraries = (activeLibrariesRes.operation || [])
        .filter((lib: any) => {
          const slug = String(lib?.Slug || '').toLowerCase();
          return slug !== 'fin' && slug !== 'processes' && slug !== 'ccp';
        });

      const dynamicCards: any[] = [];

      for (const lib of dynamicLibraries) {
        const slug = String(lib?.Slug || '').toLowerCase();
        const displayName = String(lib?.Nombre || slug.toUpperCase());

        let taskCount = 0;

        try {
          const resTask: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Task_Of_User({ ID_Involved_User: this.ID_User_BD, Status: 1, IsConsultViewTask: false }, slug));
          if (resTask.success) {
            const tasks: TASK_ALL_FIN[] = resTask.operation || [];
            taskCount = tasks.length;
          }
        } catch (error) {
          taskCount = 0;
        }

        dynamicCards.push({
          Name_library: displayName,
          RouteLink: `/Dashboard/FIN/SeeAllTasksLibFIN?LibrarySlug=${encodeURIComponent(slug)}&LibraryName=${encodeURIComponent(displayName)}&BaseRoute=${encodeURIComponent(`/Dashboard/Lib/${slug}`)}`,
          Task: taskCount,
          Key: displayName
        });
      }

      if (dynamicCards.length > 0) {
        this.AllLibrariesCopy.push({
          Title: 'Librerías dinámicas',
          NotRelated: [],
          LibraryRole: [],
          Library: dynamicCards
        });
      }
    } catch (error) {
      // Si falla la carga dinámica, mantenemos la vista estándar de FIN sin bloquear el módulo.
    }
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\





  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR GREETTING ==================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }


  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  public GetRoutePath(routeLink: string): string {
    return String(routeLink || '').split('?')[0] || '/Dashboard/General/SeeAllTaskCDMS';
  }

  public GetRouteQueryParams(routeLink: string): Record<string, string> {
    const route = String(routeLink || '');
    const query = route.split('?')[1] || '';
    const params = new URLSearchParams(query);
    const result: Record<string, string> = {};

    params.forEach((value, key) => {
      result[key] = value;
    });

    return result;
  }
}
